import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { classNames } from '@utils/genUtils'
import React from 'react'
import CourseDiffItem from './courseDiffItem'
import { twMerge } from 'tailwind-merge'

export interface ICourseDiffItem {
  title: string
  description: string
  image: IGatsbyImageDataObject
}
interface Props {
  items: ICourseDiffItem[]
  headlineClasses?: string
  subHeadlineClasses?: string
  subHeadline?: string
  ItemComponent: React.ComponentType<{
    item: ICourseDiffItem,
    titleClasses?: string
    descriptionClasses?: string
  }>
  itemTitleClasses?: string
  itemDescriptionClasses?: string
}

function WhatMakesCourseDiffList(props: Props) {
  const { items, headlineClasses, ItemComponent, subHeadlineClasses = '', itemTitleClasses, itemDescriptionClasses, subHeadline } = props

  return (
    <div className='et-grid-basic col-span-full'>

      {/* HEADER */}
      <div className='col-span-2 col-start-2 md:text-center md:col-start-5 md:col-span-6'>
        <span className={twMerge('text-grey-500', subHeadlineClasses)}>{subHeadline ? subHeadline : 'BUILD YOUR SKILLS'}</span>
        <h2 className={twMerge(headlineClasses ? headlineClasses : 'text-grey-800', 'text-4xl md:text-5xl font-sentinel__SemiBoldItal xl:text-6xl')}>What makes this course different</h2>
      </div>

      {/* LIST */}
      <div className={`col-span-2 col-start-2 md:col-start-2 md:col-span-12 [&>*:nth-child(1)]:mt-20 md:grid md:grid-cols-2 md:gap-x-7 md:[&>*:nth-child(2)]:mt-20 lg:md:[&>*:nth-child(3)]:mt-20 lg:grid-cols-3 desktop:gap-x-16 desktop:mx-[-30px]`}>
        {/* {items.map((item, index) => (<CourseDiffItem key={index} item={item} />))} */}
        {items.map((item, index) => (<ItemComponent key={index} item={item} titleClasses={itemTitleClasses} descriptionClasses={itemDescriptionClasses} />))}
      </div>
    </div>
  )
}

export default WhatMakesCourseDiffList
